export const PAYMENT_PROGRESS_BAR_DISPLAY_NAME = 'PaymentProgressBar'
export const PAYMENT_PROGRESS_CIRCLE_DISPLAY_NAME = 'PaymentProgressCircle'

export const KINDS = {
  CIRCLE: 'Circle',
  BAR: 'Bar',
} as const

export const SIZES = {
  EXTRA_LARGE: 'ExtraLarge',
  LARGE: 'Large',
  REGULAR: 'Regular',
  SMALL: 'Small',
  EXTRA_SMALL: 'ExtraSmall',
} as const
